<template>
  <b-modal
    scrollable
    @show="show"
    id="products-category-modal"
    ref="modal"
    :title="'Zarządzaj Kategoriami'"
    size="lg"
    :hide-footer="true"
  >
    <b-row inline class="category-header mt-0">
      <h5>Nazwa kategori</h5>
      <h5>Opcje</h5>
    </b-row>

    <products-category-input :isBusy="isBusy || loading" :options="options" ref="productsCategoryInput" :parentId="selected" @add="saveNew"/>

    <table-spiner v-if="loading" />
    <category-tree v-if="root.children.length && !loading" :categories="root.children" @edit="showEditModal" @remove="showRemoveModal"/>

    <edit-category-modal ref="editModal" @ok="edit" />
    <remove-category-modal ref="removeModal" @ok="remove"/>
  </b-modal>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import TableSpiner from "@/components/TableSpiner";
import CategoryTree from "./CategoryTree/index.vue";
import RemoveCategoryModal from './RemoveCategoryModal.vue';
import EditCategoryModal from './EditCategoryModal.vue';
import ProductsCategoryInput from './ProductsCategoryInput.vue';
import { flatenCategories } from '@/utils/index.js';

export default {
  name: "ProductsCategoryModalForm",
  data() {
    return {
      loading: true,
      newCategoryError: null,
      noError: null,
      q: "",
      filterOn: ["name"],
      isBusy: false,
      selected: 0
    };
  },
  computed: {
    ...mapGetters('products', ['root']),
    options() {
      return flatenCategories(this.root, 0);
    }
  },
  methods: {
    ...mapActions("products", ["getCategories", "addCategory", "removeCategory", "editCategory"]),
    ...mapMutations("products", ["pushToParent", "removeFromParent"]),
    async show() {
      this.loading = true;
      try {
        await this.getCategories();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    validInput() {
      if (this.$refs.categoryName.localValue.length === 0) {
        this.noError = false;
      } else {
        this.noError = null;
      }
    },
    showRemoveModal(item) {
      this.$refs.removeModal.show(item);
    },
    showEditModal(item) {
      this.$refs.editModal.show({ item, options: this.options });
    },
    remove({id, parent_id}) {
      this.$Progress.start();
      const modal = this.$refs.removeModal;
      const input = this.$refs.productsCategoryInput;
      this.removeCategory(id)
        .then(() => {
          this.removeFromParent({id, parent_id});
          this.selected = 0;
          input.reset();
          modal.hide();
        })
        .catch((error) => {
          this.isBusy = false;
          modal.error(error);
        })
    },
    edit(item) {
      const modal = this.$refs.editModal;
      const {id, body, originalElement} = item;
      this.editCategory({id, body})
        .then(() => {
          originalElement.name = body.name;
          if (originalElement.parent_id !== body.parent_id) {
            const draft = {...originalElement};
            this.removeFromParent(draft, draft.parent_id);
            draft.parent_id = body.parent_id;
            this.pushToParent({element: draft, parent_id: draft.parent_id});
          }
          modal.continue();
        });
    },
    stopEdit() {
      this.noError = null;
    },
    saveNew({selected, value}) {
      this.isBusy = true;
      this.$Progress.start();
      const input = this.$refs.productsCategoryInput;
      this.selected = selected;
      this.addCategory({
        name: value,
        parent_id: selected
      }).then(data => {
        this.newCategory = "";
        this.pushToParent({element: data.data, parent_id: selected});
        this.isBusy = false;
        input.reset();
      });
    },
    saveEdited() {
    }
  },
  components: {
    CategoryTree,
    RemoveCategoryModal,
    EditCategoryModal,
    ProductsCategoryInput,
    TableSpiner
  }
};
</script>